<template>
  <div class="slider-image-text-block-inner">
    <div class="wrapper">
      <h2 class="text-subheader">{{ title }}</h2>
      <div class="swiper-container">
        <Swiper
          class="slider-image-text-block"
          :modules="[Pagination, Navigation]"
          :slides-per-view="'auto'"
          :space-between="24"
          :loop="textBlocks.length > 1"
          navigation
          :pagination="{
            clickable: true,
          }"
        >
          <SwiperSlide
            v-for="(slide, index) in textBlocks"
            :key="`slider_text_block_${index}`"
            v-slot="{ isActive }"
          >
            <CImageTextBlock
              :title="slide.title"
              :button="slide.button"
              :image="slide.image"
              :image-seo="slide.imageSeo"
              :text="slide.text"
              :is-visible-image="isActive"
              :button-text="slide.button"
              :button-trigger="slide.buttonTrigger"
              :image-is-rounded="slide.imageIsRounded"
              :is-reverse="slide.isReverse"
              :block-id="slide.blockId"
              :media-id="slide.mediaId"
            />
          </SwiperSlide>
        </Swiper>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination } from 'swiper';
import CImageTextBlock from '~/components/blocks/imageTextBlock/CImageTextBlock.vue';
import type { BlockButtonTrigger, ImageItem, ImageSEO } from '~/types/pages';
import './styles.scss';

interface Props {
  title: string;
  textBlocks: {
    title: string;
    image: ImageItem;
    imageSeo: ImageSEO;
    text: string;
    isReverse: boolean;
    imageIsRounded: boolean;
    button: string;
    buttonTrigger: BlockButtonTrigger;
  }[];
}

defineProps<Props>();
</script>

<style scoped></style>
